import React from "react";

const Features = () => {
  return (
    <>
      <div className="pb-32">
        <h2 className="w-full mb-20 text-5xl font-bold leading-tight text-center text-letter-color">
          What can you do with Dynabench?
        </h2>
        <div className="grid grid-cols-1 md:gap-16 md:grid-cols-2">
          <div className="flex mb-12">
            <div className="shrink-0">
              <div className="p-4 rounded-md shadow-lg bg-[#0e1015]">
                <svg
                  viewBox="0 0 1179 1179"
                  className="w-5 h-5 text-white icon"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#000000"
                >
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M597.215632 994.574713h403.714943s43.549425-8.945287 43.549425-114.64092 94.16092-577.677241-459.976092-577.677241-457.151264 541.425287-457.151264 541.425287-25.423448 160.77977 54.848735 157.013333 415.014253-6.12046 415.014253-6.120459z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M1071.786667 712.798161h72.503908v136.297931h-72.503908zM36.016552 712.798161h72.503908v136.297931H36.016552z"
                      fill="#ccebd4"
                    />
                    <path
                      d="M305.68366 559.40926l556.254412-1.165018 0.398364 190.20464-556.254412 1.165018-0.398364-190.20464Z"
                      fill="#bdbdbd"
                    />
                    <path
                      d="M1129.931034 680.312644h-59.556781c-3.295632-152.069885-67.56046-258.942529-172.079081-324.384368l115.347127-238.462529a47.08046 47.08046 0 1 0-42.372414-20.48l-114.640919 236.57931a625.934713 625.934713 0 0 0-269.30023-53.200919 625.228506 625.228506 0 0 0-270.006437 54.848736l-115.817931-235.402299a47.08046 47.08046 0 1 0-42.372414 20.715402l117.701149 238.462529c-103.812414 65.441839-167.135632 173.02069-169.960459 324.61977H47.786667a47.08046 47.08046 0 0 0-47.08046 47.08046v117.701149a47.08046 47.08046 0 0 0 47.08046 47.08046h58.615172v57.908965a70.62069 70.62069 0 0 0 70.62069 70.62069l823.908046-1.647816a70.62069 70.62069 0 0 0 70.620689-70.62069v-57.908965h59.085977a47.08046 47.08046 0 0 0 47.08046-47.08046v-117.701149A47.08046 47.08046 0 0 0 1129.931034 680.312644zM94.16092 847.212874H47.08046v-117.70115h47.08046v117.70115z m929.83908 103.106206a23.54023 23.54023 0 0 1-23.54023 23.54023l-823.908046 1.647816a23.54023 23.54023 0 0 1-23.54023-23.540229v-258.942529c0-329.563218 303.668966-365.57977 434.788046-365.815173s435.494253 34.604138 436.20046 363.931954z m105.46023-105.224827h-47.08046v-117.70115h47.08046v117.70115z"
                      fill="#3F4651"
                    />
                    <path
                      d="M464.684138 135.827126l22.363218-19.53839 40.018391 62.381609a30.131494 30.131494 0 0 0 25.423448 13.888735h2.824828a30.131494 30.131494 0 0 0 25.188046-19.067586l20.715402-79.095172 21.186207 74.387126v2.118621a30.366897 30.366897 0 0 0 52.494713 6.826667l30.366896-57.202759 13.182529 12.947126a30.131494 30.131494 0 0 0 21.186207 8.709886h57.673563a23.54023 23.54023 0 0 0 23.54023-23.54023 23.54023 23.54023 0 0 0-23.54023-23.54023h-50.140689l-23.54023-23.54023a30.366897 30.366897 0 0 0-45.668046 3.766437l-21.42161 40.01839L629.465747 19.302989a30.131494 30.131494 0 0 0-28.012873-19.067587 30.131494 30.131494 0 0 0-28.012874 19.067587l-26.60046 101.693793-29.660689-47.08046a30.366897 30.366897 0 0 0-20.48-13.653333 30.837701 30.837701 0 0 0-23.54023 6.826666l-32.250115 28.248276h-60.027586a23.54023 23.54023 0 0 0-23.54023 23.54023 23.54023 23.54023 0 0 0 23.54023 23.54023h66.148046a31.308506 31.308506 0 0 0 17.655172-6.591265zM776.121379 532.950805H404.421149A121.232184 121.232184 0 0 0 282.482759 639.352644a117.701149 117.701149 0 0 0 117.701149 129.000459h371.70023a121.232184 121.232184 0 0 0 121.938391-106.401839 117.701149 117.701149 0 0 0-117.70115-129.000459z m0 188.321839H402.302529a72.503908 72.503908 0 0 1-72.268506-56.496552 70.62069 70.62069 0 0 1 68.972874-84.744828h373.81885a72.503908 72.503908 0 0 1 72.268506 56.496552 70.62069 70.62069 0 0 1-68.502069 84.744828z"
                      fill="#3F4651"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="ml-4 grow">
              <p className="mb-1 text-xl font-bold text-letter-color">
                Outsmart advanced AI models:
              </p>
              <p className="text-lg text-letter-color">
                Take on the best in the game by competing against models like
                BERT, GPT, DALLE, YOLO, and more, and see if you can outperform
                them in a specific challenge or dataset.
              </p>
            </div>
          </div>

          <div className="flex mb-12">
            <div className="shrink-0">
              <div className="p-4 rounded-md shadow-lg bg-[#0e1015]">
                <svg
                  className="w-5 h-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="ml-4 grow">
              <p className="mb-1 text-xl font-bold text-letter-color">
                Create cutting-edge challenges
              </p>
              <p className="text-lg text-letter-color">
                Push the boundaries of AI by creating your own challenges that
                address critical issues such as safety, robustness, fairness,
                adversarial AI, and data-centricity. Get creative and design
                challenges that truly test the limits of AI.
              </p>
            </div>
          </div>
          <div className="flex mb-12">
            <div className="shrink-0">
              <div className="p-4 rounded-md shadow-lg bg-[#0e1015]">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-white"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />

                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <g id="Communication / Share_Android">
                      {" "}
                      <path
                        id="Vector"
                        d="M9 13.5L15 16.5M15 7.5L9 10.5M18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21ZM6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12C9 13.6569 7.65685 15 6 15ZM18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9Z"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />{" "}
                    </g>{" "}
                  </g>
                </svg>
              </div>
            </div>
            <div className="ml-4 grow">
              <p className="mb-1 text-xl font-bold text-letter-color">
                Share your own AI models (Dynalab){" "}
              </p>
              <p className="text-lg text-letter-color">
                Submit your own AI models to various challenges and datasets,
                and get recognized for your innovative approaches in areas such
                as computer vision, natural language processing, speech
                recognition, coreset selection and more.
              </p>
            </div>
          </div>

          <div className="flex">
            <div className="shrink-0">
              <div className="p-4 rounded-md shadow-lg bg-[#0e1015]">
                <svg
                  className="w-5 h-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 544 512"
                >
                  <path
                    fill="currentColor"
                    d="M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="ml-4 grow">
              <p className="mb-1 text-xl font-bold text-letter-color">
                Collaborate with peers and experts
              </p>
              <p className="text-lg text-letter-color">
                Dynabench offers a unique opportunity to connect with other
                like-minded individuals and experts in the AI community. You'll
                be at the forefront of the latest advancements in AI research.
                Keep your skills sharp and stay ahead of the curve by getting
                involved in the Dynabench community.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
